export function isInsideDashboard() {
    return new URLSearchParams(window.location.search).get("from") === "dashboard";
}